import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { PermissionService } from './permission.service';
import { Permission } from '../security/permission';

export function permissionGuard(permission: Permission): CanActivateFn {
  return () => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    return permissionService.permissionsLoaded$.pipe(
      filter(loaded => loaded),
      take(1),
      map(() => {
        if (permissionService.hasPermission(permission)) {
          return true;
        }
        router.navigate(['/dashboard']);
        return false;
      })
    );
  };
}

